<div class="row d-flex">
  <div class="col-12 p-5">
    <div class="row">
      <span *ngIf="mostrarBotaoVoltar" data-testid="botao-voltar" class="back-button" (click)="voltar.emit()">
        <i class="fas fa-angle-left"></i> voltar
      </span>
    </div>
    <div id="header-empresa" class="form-row">
      <h3 class="form-title text-center">{{ titulo }}</h3>
    </div>
    <div class="custom-box-alert credor-info mb-5">
      <i class="fas fa-info-circle"></i>
      <p>
        O Representante Legal da empresa será responsável por todos os atos em nome da Pessoa Jurídica.
        É obrigatório o cadastro de ao menos 01 (um) Representante Legal que possui poderes de representação conforme Estatuto ou Contrato Social da empresa.
      </p>
    </div>
    <form [formGroup]="formEmpresa">
      <div class="container-empresa" formArrayName="empresas">
        <div id="formEmpresas" class="col" *ngFor="let emp of empresasPJ.controls; let e = index" [formGroupName]="e">
          <div class="form-row align-items-center">
            <div class="col">
              <h3 class="text-credor">Credor Pessoa Juridica {{ e + 1 }}</h3>
            </div>
            <div *ngIf="!emp.get('remove').value" class="col-auto">
              <button class="btn-trash text-end" type="button" (click)="removerEmpresa.emit(e)">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-5">
              <label class="form-label">
                CNPJ *
              </label>
              <input data-testid="cnpj-credor" autocomplete="off" type="text" formControlName="cnpj"  mask="AA.AAA.AAA/AAAA-AA" class="form-control custom-input">
              <span class="error-form ml-2" *ngIf="emp.get('cnpj')?.invalid && (emp.get('cnpj')?.dirty || emp.get('cnpj')?.touched)">Campo obrigatório.</span>

            </div>
            <div class="col-md">
              <label class="form-label">
                Razão Social *
              </label>
              <input data-testid="razaoSocial-credor" autocomplete="off" type="text" maxlength="150" formControlName="nomeEmpresa" class="form-control custom-input">
              <span class="error-form ml-2" *ngIf="emp.get('nomeEmpresa')?.hasError('required') && (emp.get('nomeEmpresa')?.dirty || emp.get('nomeEmpresa')?.touched)">Campo obrigatório.</span>
              <span class="error-form ml-2" *ngIf="emp.get('nomeEmpresa')?.hasError('pattern')">Campo contém caracteres inválidos.</span>
            </div>
          </div>

          <!-- Representantes -->
          <div formArrayName="representantes">
            <div class="mt-5" *ngFor="let rep of getRepresentantes(e).controls; let i = index" [formGroupName]="i">
              <div class="form-row align-items-center">
                <div class="col">
                  <h3 class="text-credor">Representante Legal {{ i + 1 }}</h3>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-5">
                  <label class="form-label">
                    Nome <b class="form-label" *ngIf="i === 0">*</b>
                  </label>
                  <input data-testid="nome-representante" autocomplete="off" type="text" formControlName="nome"  class="form-control custom-input">
                  <span class="error-form ml-2" *ngIf="rep.get('nome')?.hasError('required') && (rep.get('nome')?.dirty || rep.get('nome')?.touched)">Campo obrigatório.</span>
                </div>
                <div class="col-md">
                  <label class="form-label">
                    CPF <b class="form-label" *ngIf="i === 0">*</b>
                  </label>
                  <input data-testid="cpf-representante" autocomplete="off" type="text" formControlName="cpf"  mask="000.000.000-00" class="form-control custom-input">
                  <span class="error-form ml-2" *ngIf="rep.get('cpf')?.hasError('required') && (rep.get('cpf')?.dirty || rep.get('cpf')?.touched)">Campo obrigatório.</span>
                </div>
              </div>
              <div class="form-row mt-3">
                <div class="col-md">
                  <label class="form-label">
                    E-mail <b class="form-label" *ngIf="i === 0">*</b>
                  </label>
                  <input data-testid="email-representante" autocomplete="off-" type="text" formControlName="emailPj" class="form-control custom-input">
                  <span class="error-form ml-2" *ngIf="rep.get('emailPj')?.hasError('required') && (rep.get('emailPj')?.dirty || rep.get('emailPj')?.touched)">Campo obrigatório.</span>
                  <span class="error-form ml-2" *ngIf="rep.get('emailPj')?.hasError('emailInvalid') && rep.get('emailPj')?.dirty">E-mail inválido.</span>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row mt-5 d-flex container-btn">
              <button data-testid="botao-adicionar-credor" class="btn-voltar" type="button" (click)="adicionarEmpresa.emit()">
                Adicionar Credor
              </button>
              <button data-testid="botao-efetuar-cadastro" (click)="efetuarCadastro.emit()" class="btn">
                Cadastrar
              </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
